module.exports = __webpack_public_path__ + "c5812073.csv";